export const userServicesFrag = `
    id
    name
`;

export const getEmploymentsFrag = `
    id
    serviceId
`;

export const getUserGroupsFrag = `
    userId
    organizationId
    data
    group {
        id
        isPrivate
        rules {
            resource
            action
        }
    }
`;

export const organizationWithChildrenFrag = `
    id
    childOrganizations {
        id
        name
    }
`;
